import React, { useEffect } from 'react'
import { chartMock } from '../../mock'
import './styles.scss'

export const ChartView = ({
  chartHTML = chartMock,
  colors,
  isFiltersExpanded,
}) => {
  useEffect(() => {
    if (!colors) return
    Object.entries(colors).forEach(([theme, value]) => {
      Object.entries(value).forEach(([colorName, hexValue]) => {
        document.documentElement.style.setProperty(
          `--${colorName}-${theme}`,
          `${hexValue}`,
        )
      })
    })
  }, [colors])

  return (
    <div className={`PreflopChartView ${isFiltersExpanded ? 'expanded' : ''}`}>
      <div dangerouslySetInnerHTML={{ __html: chartHTML || chartMock }} />
    </div>
  )
}
